var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgJiobizzMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12",
    fill: "#0070b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M6.351,15.484h0a2.293,2.293,0,0,1-.572-.228l-1.028-.594V12a.8.8,0,1,0-1.6,0v1.741L1.373,12.712A3.037,3.037,0,0,1,0,10.336V5.247A3.037,3.037,0,0,1,1.373,2.87L5.779.327A2.787,2.787,0,0,1,7.151,0,2.789,2.789,0,0,1,8.523.327L12.929,2.87A3.036,3.036,0,0,1,14.3,5.247v5.089a3.037,3.037,0,0,1-1.372,2.376l-1.778,1.026V6.3a.8.8,0,1,0-1.6,0v8.364l-1.028.593a2.3,2.3,0,0,1-.571.228V9.16a.8.8,0,0,0-1.6,0v6.324Z",
    transform: "translate(4.849 4.209)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiobizzMark);
export default __webpack_public_path__ + "static/media/jiobizz-mark.78f684f5e4abafe344dbb3b562b419fa.svg";
export { ForwardRef as ReactComponent };